export const TRANSLATIONS = {
  APPROVE_BATCH_SUCCESS: (batchId: number) =>
    `Successfully approved batch ${batchId}`,
  APPROVE_BATCH_ERROR: 'Error while approving the batch',
  REJECT_BATCH_SUCCESS: (batchId: number) =>
    `Successfully rejected batch ${batchId}`,
  REJECT_BATCH_ERROR: 'Error while rejecting the batch',

  // ActivityDetails
  ACTIVITY_TITLE: 'Activities',
  UNKNOWN_USER_TITLE: 'Unknown',

  // BatchApprovalSection
  DECLINED_BY_LABEL: 'Declined by: ',
  DECLINED_BY_YOU_LABEL: 'You',
  DECLINED_VIEW_ONLY_MESSAGE: 'The batch is view-only. It can not be restored.',
  APPROVED_BY_LABEL: 'Approved by: ',
  NEEDS_APPROVAL_MESSAGE: (remaining: number) =>
    remaining === 1
      ? 'Needs to be approved by 1 person.'
      : `Needs to be approved by ${remaining} people.`,
  DECLINE_BUTTON_LABEL: 'Decline',
  APPROVE_BUTTON_LABEL: 'Approve',

  // ViewPayoutsButton
  VIEW_PAYOUT_SINGLE: 'View 1 payout',
  VIEW_PAYOUT_MULTI: (count: number) => `View ${count} payouts`
};
